import { render, staticRenderFns } from "./NewPackNotice.vue?vue&type=template&id=6cc510ee"
import script from "./NewPackNotice.vue?vue&type=script&lang=js"
export * from "./NewPackNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports